<template>
  <v-dialog width="800px" :value="value" persistent scrollable>
    <v-card class="kbLight">
      <v-toolbar class="kbRed" dark flat>
        <v-toolbar-title>
          {{business ? `${$t('general.edit')} ${businessModule.s}` : `${$t('general.new')} ${businessModule.s}`}}
        </v-toolbar-title>

        <v-spacer/>

        <v-btn icon @click="toggleModal()">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container class="pa-0" fluid>
          <v-form ref="newBusinessForm" lazy-validation>
            <v-row>
              <v-col cols="12" class="pt-6 pb-0">
                <v-text-field :label="$t('general.code')"
                              color="kbDarkBlueText"
                              v-model="businessForm.code">
                </v-text-field>
              </v-col>

              <v-col cols="12" class="pt-6 pb-0">
                <v-text-field :label="$t('general.name')"
                              color="kbDarkBlueText"
                              :rules="[rules.required]"
                              v-model="businessForm.name">
                </v-text-field>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-text-field label="Email"
                              color="kbDarkBlueText"
                              :rules="[rules.email]"
                              v-model="businessForm.email">
                </v-text-field>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-text-field :label="$t('general.phone')"
                              color="kbDarkBlueText"
                              :rules="[rules.onlyNumbers]"
                              v-model="businessForm.phone">
                </v-text-field>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-text-field :label="$t('general.address')"
                              color="kbDarkBlueText"
                              v-model="businessForm.address">
                </v-text-field>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-text-field :label="$t('general.location')"
                              color="kbDarkBlueText"
                              v-model="businessForm.location">
                </v-text-field>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-text-field :label="`${businessModule.s} Url`"
                              color="kbDarkBlueText"
                              v-model="businessForm.url">
                </v-text-field>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-combobox chips
                            color="kbDarkBlueText"
                            deletable-chips
                            :label="$t('general.categories')"
                            multiple
                            v-model="businessForm.categories">
                </v-combobox>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-text-field :label="$t('general.segment')"
                              color="kbDarkBlueText"
                              v-model="businessForm.segment">
                </v-text-field>
              </v-col>

              <v-divider/>

              <div class="pl-2" v-if="business && businessForm.others"
                   style="width: 100%">
                <span class="text-subtitle-1">{{ $t('general.extraData') }}</span>
                <v-col class="pl-0 py-0 d-flex align-center"
                       cols="12"
                       v-for="(data, key, index) in businessForm.others"
                       :key="index">

                  <v-combobox chips
                              color="kbDarkBlueText"
                              class="mr-1"
                              deletable-chips
                              :label="key.replace('_', ' ')"
                              multiple
                              v-model="businessForm.others[key]">
                  </v-combobox>

                  <v-btn icon @click="removeExtraData(key)"><v-icon color="red">mdi-close-circle</v-icon></v-btn>
                </v-col>
              </div>

              <v-col cols="12" v-for="(item, index) in newExtraDatas" :key="index">
                <v-card>
                  <v-card-text>
                    <v-text-field :label="$t('general.insertExtraDataName')"
                                  hide-details
                                  :rules="[rules.required]"
                                  v-model="newExtraDatas[index].key"/>
                    <v-combobox chips
                                deletable-chips
                                hide-details
                                :label="$t('general.insertExtraDataValues')"
                                multiple
                                :rules="[rules.required]"
                                v-model="newExtraDatas[index].value"/>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="kbRed" dark @click="removeNewExtraData(index)">
                      {{ $t('general.delete') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-btn color="white" @click="addExtraData()">
                  <span style="font-size: 16px; font-weight: 400;">{{ $t('general.addExtraData') }}</span>
                  <v-icon color="kbDarkBlue ml-1" size="25px">mdi-plus</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="12" class="pt-2 pl-4">
                <image-picker v-model="businessForm.image" title="Image"></image-picker>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>

        <v-btn @click="toggleModal()"
               class="mr-2"
               color="red"
               outlined>
          {{ $t('general.cancel') }}
        </v-btn>

        <v-btn color="kbRed"
               dark
               class="mr-2"
               @click="submit()"
               :loading="loading">
          {{this.business ? $t('general.saveChanges') : $t('general.addNewBusiness', { business: businessModule.s })}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
import ImagePicker from '@/pages/App/Events/dialogs/ImagePicker'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['businessModule'])
  },
  components: {
    'image-picker': ImagePicker
  },
  data () {
    return {
      loading: false,
      loadingBusiness: false,
      businessForm: {
        code: '',
        name: '',
        email: '',
        segment: '',
        categories: [],
        others: {},
        phone: '',
        address: '',
        url: '',
        location: '',
        image: ''
      },
      newExtraDatas: [],
      rules
    }
  },
  methods: {
    addExtraData () {
      this.newExtraDatas.push({ key: '', value: [] })
    },
    removeNewExtraData (index) {
      this.newExtraDatas.splice(index, 1)
    },
    removeExtraData (key) {
      this.$delete(this.businessForm.others, key)
    },
    async submit () {
      if (!this.$refs.newBusinessForm.validate()) return
      this.business ? await this.updateBusiness() : await this.newBusiness()
    },
    async setBusinessForm () {
      try {
        this.loadingBusiness = true
        const response = await this.$store.dispatch('getBusiness', this.$route.params.businessid)
        if (response.others && Object.keys(response.others).length > 0) {
          for (const value in response.others) {
            if (!Array.isArray(response.others[value])) {
              response.others[value] = [response.others[value]]
            }
          }
        }
        this.businessForm = { ...response }
        this.loadingBusiness = false
      } catch (error) {
        this.loadingBusiness = false
        this.error = true
        notifications.error(error.message)
      }
    },
    async newBusiness () {
      this.loading = true
      this.updateNewExtraData()
      try {
        await this.$store.dispatch('newBusiness', this.businessForm)
        notifications.success(this.$t('general.businessSuccessfullyCreated', { business: this.businessModule.s }))
        this.loading = false
        this.toggleModal()
      } catch (error) {
        this.loading = false
        notifications.error(error.message)
      }
    },
    toggleModal () {
      this.$refs.newBusinessForm.reset()
      this.newExtraDatas = []
      this.$emit('input', false)
    },
    async updateBusiness () {
      this.loading = true
      this.updateNewExtraData()
      try {
        const data = {
          businessId: this.$route.params.businessid,
          ...this.businessForm
        }
        await this.$store.dispatch('updateBusiness', data)
        notifications.success(this.$t('general.businessSuccessfullyEdited', { business: this.businessModule.s }))
        this.loading = false
        this.toggleModal()
        await this.$parent.getBusiness()
        this.newExtraDatas = []
      } catch (error) {
        this.loading = false
        notifications.error(error.message)
      }
    },
    updateNewExtraData () {
      for (const data of this.newExtraDatas) {
        if (!this.businessForm.others) {
          this.businessForm.others = {}
        }
        if (this.businessForm.others && !Object.keys(this.businessForm.others).includes(data.key.toLowerCase())) {
          this.businessForm.others[data.key.toLowerCase().replace(' ', '_')] = data.value
          console.log(this.businessForm.others)
        }
      }
    }
  },
  props: ['business', 'value'],
  watch: {
    value (value) {
      if (value && this.business) {
        this.setBusinessForm()
      }
    }
  }
}
</script>
